export default [
  {
    login: "astrahl008",
    id: 36060402,
    node_id: "MDQ6VXNlcjM2MDYwNDAy",
    avatar_url: "https://avatars2.githubusercontent.com/u/36060402?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/astrahl008",
    html_url: "https://github.com/astrahl008",
    followers_url: "https://api.github.com/users/astrahl008/followers",
    following_url:
      "https://api.github.com/users/astrahl008/following{/other_user}",
    gists_url: "https://api.github.com/users/astrahl008/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/astrahl008/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/astrahl008/subscriptions",
    organizations_url: "https://api.github.com/users/astrahl008/orgs",
    repos_url: "https://api.github.com/users/astrahl008/repos",
    events_url: "https://api.github.com/users/astrahl008/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/astrahl008/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "mbarbas11",
    id: 1631257,
    node_id: "MDQ6VXNlcjE2MzEyNTc=",
    avatar_url: "https://avatars1.githubusercontent.com/u/1631257?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/mbarbas11",
    html_url: "https://github.com/mbarbas11",
    followers_url: "https://api.github.com/users/mbarbas11/followers",
    following_url:
      "https://api.github.com/users/mbarbas11/following{/other_user}",
    gists_url: "https://api.github.com/users/mbarbas11/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/mbarbas11/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/mbarbas11/subscriptions",
    organizations_url: "https://api.github.com/users/mbarbas11/orgs",
    repos_url: "https://api.github.com/users/mbarbas11/repos",
    events_url: "https://api.github.com/users/mbarbas11/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/mbarbas11/received_events",
    type: "User",
    site_admin: false,
  },
];
